import { Gender, AddWay, CustomerStatus, ProgressStatus, CleaningStatus, OrderStatus } from './interface';

export const genderIconMap = {
  [Gender.female]: 'icon-gender-female',
  [Gender.male]: 'icon-gender-male',
};

export const addWayTextMap = {
  [AddWay.unknown]: '未知',
  [AddWay.qrCode]: '扫描二维码',
  [AddWay.searchMobile]: '搜索手机号',
  [AddWay.businessCard]: '名片分享',
  [AddWay.groupChat]: '群聊',
  [AddWay.mobileContact]: '手机通讯录',
  [AddWay.wechatContact]: '微信联系人',
  [AddWay.wechatFriendApply]: '来自微信的添加好友申请',
  [AddWay.thirdAppCustomerService]: '安装第三方应用时自动添加的客服人员',
  [AddWay.searchMail]: '搜索邮箱',
  [AddWay.innerShare]: '内部成员共享',
  [AddWay.assign]: '管理员/负责人分配',
};

// 客户好友状态配置
export const customerStatusTextMap = [
  { value: CustomerStatus.add, label: '好友' },
  { value: CustomerStatus.deleted, label: '已删除' },
  { value: CustomerStatus.resign, label: '添加人已离职' },
];

export const progressStatusTextMap = {
  [ProgressStatus.unknown]: '-',
  [ProgressStatus.lead]: '线索',
  [ProgressStatus.potential]: '商机',
  [ProgressStatus.order]: '订单',
};

export const cleaningStatusTextMap = {
  [CleaningStatus.unknown]: '-',
  [CleaningStatus.pending]: '待清洗',
  [CleaningStatus.valid]: '清洗合格',
  [CleaningStatus.invalid]: '清洗不合格',
  [CleaningStatus.tempNotValid]: '暂不合格',
  [CleaningStatus.continuable]: '继续跟进',
};

export const orderStatusTextMap = {
  [OrderStatus.submitted]: '已提单',
  [OrderStatus.paid]: '已到款',
  [OrderStatus.unpaid]: '到款驳回',
  [OrderStatus.review]: '待上线审核',
  [OrderStatus.online]: '已上线',
  [OrderStatus.notOnline]: '上线驳回',
};

export const progressStatusLinkMap = {
  [ProgressStatus.lead]: 'leads',
  [ProgressStatus.potential]: 'potentials',
  [ProgressStatus.order]: 'orders',
};

export const tableColumns = [{
  name: 'name',
  title: '企微账号',
}, {
  name: 'tagNames',
  title: '企微标签',
}, {
  name: 'corpFullName',
  title: '企微公司名称',
}, {
  name: 'addTime',
  title: '添加人/时间',
}, {
  name: 'addWay',
  title: '来源',
}, {
  name: 'description',
  title: '描述',
}, {
  name: 'status',
  title: '状态',
}, {
  name: 'leads',
  title: '关联线索信息',
}];

export const bindTableColumns = [{
  name: 'leadId',
  title: '线索ID',
}, {
  name: 'companyName',
  title: '公司名称',
}, {
  name: 'progressStatus',
  title: '阶段',
}, {
  name: 'status',
  title: '状态',
}, {
  name: 'leadFollowName',
  title: '线索跟进人',
}, {
  name: 'potentialFollowName',
  title: '商机跟进人',
}, {
  name: 'followOperatorList',
  title: '运营人员',
}, {
  name: 'contactInfos',
  title: '联系人/电话',
}];
